import {Grid} from "@mui/material"
import React from "react"

const RaterRotinas = () => {
    return (<Grid>
        </Grid>

    )
}

export default RaterRotinas